import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { isCommercialRoute, buildCommercialRedirectUrl } from '../utils/commercial-routes';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  public constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  public canActivate(
    _route: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    if (isCommercialRoute(routerState.url) && this.authService.comesFromCommercialApp) {
      window.location.href = buildCommercialRedirectUrl(routerState.url);
      return new Observable<boolean>();
    }

    return this.authService.isAuthenticated$.pipe(
      first(),
      map(
        (isAuthenticated) => {
          if (isAuthenticated && this.authService.comesFromCommercialApp) {
            return true;
          }
          return isAuthenticated ||
          this.router.createUrlTree(['/login'], {
            queryParams: { src: routerState.url }
          })
        }
      )
    );
  }
}
